import { EnvelopeIcon } from "@heroicons/react/20/solid";

export const ContactTab = (authenticatedResources) => (
  <div className="flex-grow flex flex-col px-4 py-5 sm:p-6 overflow-y-scroll">
    <h1 className="text-gray-700 text-2xl font-bold p-2">Reach out</h1>
    <h2 className="text-gray-700 text-xl p-2">
      I'm happy to answer any questions or share more resources.
    </h2>
    <div className="flex flex-wrap gap-4 text-lg pt-2">
      <a href="https://www.linkedin.com/in/luca-dovichi/" target="_blank">
        <div className="inline-flex gap-2 p-3 bg-[#0077B5] text-white font-semibold items-center hover:ring ring-[#0077B5]  transition shadow border-gray-300 border rounded-md">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="currentColor"
            viewBox="0 0 24 24"
          >
            <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
          </svg>
          LinkedIn
        </div>
      </a>
      <a href="https://github.com/Luca-W-D" target="_blank">
        <div className="inline-flex gap-2 p-3 bg-slate-800 text-white font-semibold items-center hover:ring ring-slate-800  transition shadow border-gray-300 border rounded-md">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5"
            fill="currentColor"
            viewBox="0 0 24 24"
          >
            <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z" />
          </svg>
          Github
        </div>
      </a>
      <a href={`mailto:${authenticatedResources.email}`} target="_blank">
        <div className="inline-flex gap-2 p-3 bg-gray-200 text-gray-700 font-semibold items-center hover:ring ring-gray-200  transition shadow border-gray-300 border rounded-md">
          <EnvelopeIcon className="h-5 w-5" />
          Email
        </div>
      </a>
    </div>
  </div>
);
